// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-error-handling',
//   templateUrl: './error-handling.component.html',
//   styleUrls: ['./error-handling.component.scss']
// })
// export class ErrorHandlingComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
@Component({
  selector: 'app-error-handling',
  templateUrl: './error-handling.component.html',
  styleUrls: ['./error-handling.component.scss']
})
export class ErrorHandlingComponent implements OnInit {

  isCollapsed = true;
  svgContent: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    ) { }

  ngOnInit(): void {
    this.loadSVG();
  }

  loadSVG() {
    this.http.get('../../../../../assets/SVG/logo.svg', { responseType: 'text' })
      .subscribe(svgData => {
        this.svgContent = this.sanitizer.bypassSecurityTrustHtml(svgData);
      });
  }

  onBackButtonClick(): void {
    
    this.router.navigate(['/']);
  }

}
